import React, { useEffect, useRef, useState } from 'react'
import { IQuizResponse, IWorkplaceQuizState } from '../../models/WorkplaceQuiz'
import Conditional from '../common/Conditional'
import { createMarkupWithOption } from '../../models/Common'

export interface IWorkplaceQuizModuleIntroProps {
  quizResponse: IQuizResponse
  quizStatus: IWorkplaceQuizState
  startQuiz: () => void
  startAgain: () => void
  viewResult: () => void
  handleErrors?: (any) => void
}

const WorkplaceQuizModuleIntro = (props: IWorkplaceQuizModuleIntroProps) => {
  const mountedRef = useRef(false)
  const [isLoading, setIsLoading] = useState(true)
  const [quiz, setQuiz] = useState<IQuizResponse>()
  const [quizStatus, setQuizStatus] = useState<IWorkplaceQuizState>()

  useEffect(() => {
    mountedRef.current = true
    if (mountedRef.current) {
      setQuizStatus(props.quizStatus)
      setQuiz(props.quizResponse)
      setIsLoading(false)
    }

    return () => {
      mountedRef.current = false
    }
  }, [props.quizResponse, props.quizStatus])

  const start = () => {
    props.startQuiz()
  }

  const startAgain = () => {
    props.startAgain()
  }
  const onKeyPressStartAgain = async (event) => {
    if (event.keyCode === 13) {
      props.startAgain()
    }
  }

  const onKeyPressCompleted = async (event) => {
    if (event.keyCode === 13) {
      viewResult()
    }
  }

  const viewResult = () => {
    props.viewResult()
  }

  return (
    <Conditional if={!isLoading && quiz && quizStatus}>
      <div className="contentHolder">
        <div
          className="contentTitle"
          dangerouslySetInnerHTML={createMarkupWithOption(
            quiz?.introTitleContent,
            { ADD_ATTR: ['target'] }
          )}
        ></div>
        <div
          className="contentText"
          dangerouslySetInnerHTML={createMarkupWithOption(
            quiz?.introductionContent,
            { ADD_ATTR: ['target'] }
          )}
        ></div>
      </div>

      <Conditional if={!quizStatus?.completed}>
        <div></div>
        <div className="buttonArea">
          <div className={`center time time${quiz?.duration}`}>
            <p>{quiz?.timeContent}</p>
          </div>

          <a
            onClick={() => start()}
            role="button"
            tabIndex={0}
            onKeyDown={onKeyPressStartAgain}
            className="button is-primary"
          >
            {`${quiz?.resume == true ? 'Resume' : 'Start'}`}
          </a>
        </div>
      </Conditional>
      <Conditional if={quizStatus?.completed}>
        <p className="completeText">You have completed this section</p>

        <a
          className="button is-secondary"
          onClick={() => startAgain()}
          onKeyDown={onKeyPressStartAgain}
          role="button"
          tabIndex={0}
        >
          Start again
        </a>

        <a
          className="button is-primary"
          onClick={() => viewResult()}
          onKeyDown={onKeyPressCompleted}
          role="button"
          tabIndex={0}
        >
          View results summary
        </a>
      </Conditional>
    </Conditional>
  )
}

export default WorkplaceQuizModuleIntro
